module.exports = __webpack_public_path__ + "img/wilsona.9cae45a1.jpg";